import { findRequestType } from '../../../utils/mappings';
import { localDateFormat } from '../../../utils/timeFormat';
import { IRequest } from '../interfaces/IRequest';

// Matches against the text shown on each request list item so users can filter by what they see.
export const requestMatchesTextFilter = (request: IRequest, searchString: string): boolean => {
    const search = searchString?.trim().toLowerCase();
    if (!search) return true;

    const searchableText = [
        request.SubRequestTypeLabel,
        request.RequestTypeLabel,
        findRequestType(request.Type)?.text,
        request.RequestFor?.Name,
        request.RequestTo?.Name,
        request.RequestFrom?.Name,
        request.TimelineEvents?.[0]?.InitiatorName,
        request.CreatedOn ? localDateFormat(new Date(request.CreatedOn)) : undefined,
    ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

    return searchableText.includes(search);
};
